import { render } from "./SectionTechFrontChatBottom.vue?vue&type=template&id=2bd4be0c&scoped=true"
import script from "./SectionTechFrontChatBottom.vue?vue&type=script&lang=js"
export * from "./SectionTechFrontChatBottom.vue?vue&type=script&lang=js"

import "./SectionTechFrontChatBottom.vue?vue&type=style&index=0&id=2bd4be0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd4be0c"]])

export default __exports__